import * as React from 'react';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import {
  LocalizationProvider,
  loadMessages,
  load,
  IntlProvider,
} from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../../AlertsGrid/GridLocale';
import { Divider } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import esMessages from '../../../utils/gridMessageKey.json';
loadMessages(esMessages, 'fr-CA');
import TrendsFilter from './TrendsFilter';
import DeviceIssueTrendsLineChart from './DeviceIssueTrendsLineChart';

// Styles
const useStyles = makeStyles((theme: Theme) => createStyles({}));

const TrendsContainer: React.FC = (): React.ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  return (
    <React.Fragment>
      <LocalizationProvider language={currentLocale.language}>
        <IntlProvider locale={currentLocale.locale}>
          <TrendsFilter />
          <Divider />
          <DeviceIssueTrendsLineChart />
        </IntlProvider>
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default TrendsContainer;
